import React from 'react';
import { RadialHeaderList } from '../RadialHeaderList/RadialHeaderList';
import { PmrValidationStateTable } from './PmrValidationStateTable/PmrValidationStateTable';
import { useSelector } from 'react-redux';
import { ProjectsListSkeleton } from '../../LoadersSkeletons/ProjectsListSkeleton/ProjectsListSkeleton';

type Props = {
  headerTitle: Function;
};
export const PmrValidationState = ({ headerTitle }: Props) => {
  const loadingRedux = useSelector<any, boolean>(state => state.dataTableInfo.loading);
  return (
    <div>
      <RadialHeaderList headerTitle={headerTitle} />
      {!loadingRedux ? <PmrValidationStateTable /> : <ProjectsListSkeleton />}
    </div>
  );
};
